import { TableCell, TableRow, Tooltip } from '@mui/material';
import { styled } from '@mui/system';

const StyledTableRow = styled(TableRow)({
  '&:hover': {
    backgroundColor: '#e6f7ff',  // Light grey background on hover
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },
});

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderBottom: '1px solid #dee2e6',  // Light grey bottom border
  padding: theme.spacing(1),
}));

function PricingTableRow({ row, termFilter }) {
  const calculateCost = (perHour) => (perHour * 24 * 30).toFixed(2);
  const calculateSavingsPercentage = (perHour, reservedHour) => (100 * ((perHour - reservedHour) / perHour)).toFixed(2);

  const isReservedAvailable = row["per_hour_three_year_reserved"] !== -1;
  const isSavingsPlanAvailable = row["per_hour_three_year_savings_plan"] !== -1;

  return (
    <StyledTableRow key={row.name}>
      <StyledTableCell component="th" scope="row">
        {row.name}
      </StyledTableCell>
      <StyledTableCell align="right">
        {row.region_name}
      </StyledTableCell>
      <StyledTableCell align="right"  style={{ borderLeft: '1px solid #dee2e6', borderRight: '1px solid #lightgray' }}>
        {row.vCPUs} vCPU
      </StyledTableCell>
      <StyledTableCell align="right"  style={{ borderLeft: '1px solid #dee2e6', borderRight: '1px solid #lightgray' }}>
        {row.MemoryGB} GB
      </StyledTableCell>
      <StyledTableCell align="right"  style={{ borderLeft: '1px solid #dee2e6', borderRight: '1px solid #lightgray' }}>
        {row.CpuArchitectureType}
      </StyledTableCell>
      <StyledTableCell align="right" style={{ borderLeft: '1px solid #dee2e6', borderRight: '1px solid #lightgray' }}>
          ${calculateCost(row.perhour)}
      </StyledTableCell>
      <StyledTableCell align="right">
          {isReservedAvailable
            ? <>
                  ${termFilter === '3 Years'
                  ? calculateCost(row.per_hour_three_year_reserved)
                  : calculateCost(row.per_hour_one_year_reserved)
                }
                <span style={{ color: 'green', display: 'inline-flex', alignItems: 'center', marginLeft: '8px' }}>
                    <sub><b>{termFilter === '3 Years' ?
                        calculateSavingsPercentage(row.perhour, row.per_hour_three_year_reserved):
                        calculateSavingsPercentage(row.perhour, row.per_hour_one_year_reserved)}%</b></sub>
                     <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                         <path d="M8 10L13 5L3 5L8 10Z" fill="green"/>
                  </svg>
                </span>
              </>
              : <b>--</b>
          }
      </StyledTableCell>
      <StyledTableCell align="right">
          {isSavingsPlanAvailable
            ? <>
                  ${termFilter === '3 Years'
                  ? calculateCost(row.per_hour_three_year_savings_plan)
                  : calculateCost(row.per_hour_one_year_savings_plan)
              }
                <span style={{ color: 'green', display: 'inline-flex', alignItems: 'center', marginLeft: '8px' }}>
                    <sub><b>{termFilter === '3 Years' ?
                        calculateSavingsPercentage(row.perhour, row.per_hour_three_year_savings_plan):
                        calculateSavingsPercentage(row.perhour, row.per_hour_one_year_savings_plan)}%</b></sub>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 10L13 5L3 5L8 10Z" fill="green"/>
                    </svg>
                </span>
              </>
              : <b>--</b>
          }
      </StyledTableCell>
    </StyledTableRow>
  );
}

export default PricingTableRow;
